import { gql } from '@apollo/client';

export const LIST_PROMOTION_AND_DISCOUNT_CUPONS=gql`
     query($profile_uuid:ID!, $first:Int, $page:Int, $type:String){
          listPromotionAndDiscountCupons(profile_uuid:$profile_uuid, first:$first, page:$page, type:$type){
               edge{
                    id,
                    title,
                    alt,

                    valid_to,
                    type,

                    image_url,
                    visible
               },
               total
          }
     }
`;